import { render, staticRenderFns } from "./CommonQuestions.vue?vue&type=template&id=24e59a28&scoped=true"
import script from "./CommonQuestions.vue?vue&type=script&lang=js"
export * from "./CommonQuestions.vue?vue&type=script&lang=js"
import style0 from "./CommonQuestions.vue?vue&type=style&index=0&id=24e59a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e59a28",
  null
  
)

export default component.exports